





























import { Component, Vue } from 'vue-property-decorator';
import { QuizColors } from '../quiz';

enum RESULT_TYPE {
  KURTZ,
  MARLOW,
  ACCOUNTANT,
  MANAGER,
  OPPOSITE,
  SAME,
  INCONCLUSIVE
}

@Component({})
export default class Results extends Vue {
  getResults() {
    // Kurtz - You most resemble Kurtz!
    // Marlow - You most resemble Marlow!
    // Accountant - You most resemble the Accountant!
    // Manager - You most resemble the Manager!
    // Opposite (Marlow + X) - You are the Opposite!
    // Same (X + X) - You are the Company!
    // Inconclusive - You are all forms!

    // Identify the maximum and see if there are multiple.
    let maxChars: any[] = []
    let maxScore = Object.values(this.$store.state.quizScore)[0]
    for (let attr in this.$store.state.quizScore) {
      if (this.$store.state.quizScore[attr] > maxScore) {
        maxChars = [attr]
        maxScore = this.$store.state.quizScore[attr]
      } else if (this.$store.state.quizScore[attr] === maxScore) {
        maxChars.push(attr)
      }
    }

    if (maxChars.length === 1) {
      // distinguish by character
      switch(maxChars[0]) {
        case "kurtz": return RESULT_TYPE.KURTZ
        case "marlow": return RESULT_TYPE.MARLOW
        case "accountant": return RESULT_TYPE.ACCOUNTANT
        case "manager": return RESULT_TYPE.MANAGER
        default: return RESULT_TYPE.INCONCLUSIVE
      }
    } else if (maxChars.length === 4 && maxScore === 0) {
      return RESULT_TYPE.INCONCLUSIVE
    } else if (maxChars.length >= 1) {
      if (maxChars.indexOf("marlow") !== -1) {
        return RESULT_TYPE.OPPOSITE
      } else {
        return RESULT_TYPE.SAME
      }
    }
  }

  getScoreString(character: string) {
    const score = this.$store.state.quizScore[character]
    if (Math.abs(score) <= 2) { return `~${score}` }
    return score > 0 ? `+${Math.abs(score)}` : `-${Math.abs(score)}`
  }

  getScoreStatus(character: string) {
    const score = this.$store.state.quizScore[character]
    if (Math.abs(score) <= 2) { return 'SMALL' }
    else if (score === 0) { return 'NULL' }
    else if (score >= 5) { return 'HIGH POS' }
    else if (score >= 2) { return 'POS' }
    else if (score <= -5) { return 'HIGH NEG' }
    else if (score <= -2) { return 'NEG' }
    else { return 'NULL' }
  }

  getTitleResults() {
    const results = this.getResults()

    switch (results) {
      case RESULT_TYPE.KURTZ: return "You resemble Kurtz!"
      case RESULT_TYPE.MARLOW: return "You resemble Marlow!"
      case RESULT_TYPE.ACCOUNTANT: return "You resemble the Accountant!"
      case RESULT_TYPE.MANAGER: return "You resemble the Manager!"
      case RESULT_TYPE.OPPOSITE: return "You resemble Marlow + the Company!"
      case RESULT_TYPE.SAME: return "You resemble the Company!"
      default: return "Your mind is an enigma!"
    }
  }

  getDescResults() {
    const results = this.getResults()
    
    if (results === RESULT_TYPE.KURTZ) {
      return "Your personality is rare among your peers. You're courageous and overconfident, and you're not afraid to... be a little savage in your methods."
    } else if (results === RESULT_TYPE.MARLOW) {
      return "You are an introspective explorer. You may show glimpses of young naivete, but your deep passion to explore will eventually accomodate for it and beyond."
    } else if (results === RESULT_TYPE.ACCOUNTANT) {
      return "You're very work-oriented and diligent to the point that it might blind you to the changing world around you. Be careful with your work and future prospects."
    } else if (results === RESULT_TYPE.MANAGER) {
      return "You enjoy bossing people around and the raw taste of power. Imperial colonialization might be a pipe dream for you."
    } else if (results === RESULT_TYPE.OPPOSITE) {
      return "Intriguing! You've managed to mix Marlow and the Company equally. We're not entirely sure what kind of person results from this mix, but it's interesting nonetheless."
    } else if (results === RESULT_TYPE.SAME) {
      return "Not only did you manage to score high enough to get Kurtz, but you've also scored just as high as the other members of the company! We just hope you don't go on any colonial expeditions soon.."
    } else {
      return "We really couldn't determine what kind of person you were. Maybe you were being too safe with your responses? Or perhaps you weren't answering the test honestly?"
    }
  }

  getColors() {
    const colors = QuizColors[this.getResults() || 0]
    return {
      '--quiz-accent': colors.acc,
      '--quiz-fore': colors.fore,
    }
  }
}
